import styled from '@emotion/styled';
import { css } from '@emotion/react';

// TODO: alias box-shadow to fixed
export const Container = styled('div')(
    ({ theme: { borderRadius, boxShadow, colors } }) => css`
        border-radius: ${borderRadius['300']};

        box-shadow: ${boxShadow['200']};

        ${Button} {
            border: 1px solid ${colors['graphic-divider']};
            border-bottom: 1px solid ${colors['graphic-divider']};
            border-radius: ${borderRadius['300']};

            &:focus {
                border-color: transparent;
            }

            &svg:first-of-type {
                border-bottom: none;
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
            &:last-child {
                border-top-left-radius: 0;
                border-top-right-radius: 0;
            }
        }
    `
);

export const Button = styled('button')(
    ({ theme: { colors, focusRing } }) => css`
        position: relative;
        display: block;
        width: 2.25rem;
        height: 2.25rem;
        border: 0;
        background: ${colors.white};
        cursor: pointer;

        &:focus {
            box-shadow: ${focusRing};
            outline: 0;
            z-index: 1;
        }
    `
);
